import { entryPoint } from "../util";
import { Promo } from "./promo";

entryPoint(Promo);
